<template>
  <div class="widget-list">
    <b-table class="widget-table" :items="alertItems" :fields="alertFields" :state="alertShadow">

       <!--- Date -->
      <template v-slot:cell(Data)="{ item: item }">
        <strong :style="item.Online==true?colorBlack:colorGrey">{{item.Data.split("\n")[0]}}</strong>
        <br />
        <p :style="item.Online==true?colorBlack:colorGrey">{{item.Data.split("\n")[1]}}</p>
      </template>

      <!--- Info luminaire -->
      <template v-slot:cell(Dev)="{ item: item }">
        <strong class="font-16m" :style="item.Online==true?colorBlack:colorGrey">{{item.Cent}}</strong>
        <br />
        <p :style="item.Online==true?colorBlack:colorGrey">{{item.Dev}} {{item.Type}}</p>
      </template>

      <!--- Icon -->
      <template v-slot:cell(Icon)="{ item: { Icon,Online } }">
        <i v-if="Icon.includes('wifi')" id="orphanIcon" :class="'fa ' + Icon" :style="colorIcon"></i>
        <i v-else :class="'fa ' + Icon" :style="Online==true?(Icon.includes('fa-exclamation-circle')?colorCom:colorIcon):colorGrey"></i>
        <br></br>
      </template>

      <!--- Desc -->
      <template v-slot:cell(Desc)="{ item: item  }">
        <p :style="item.Online==true?colorBlack:colorGrey">{{item.Desc}}<br>
        <span v-if="item.Online!=true">{{item.Dev}} Offline</span>
        </p>
      </template>

      
    </b-table>
  </div>
</template>

<script>

export default {
  name: "alertOverview",
  data() {
    return {
      //heading e valori della tabella alert    :state="alertShadow"
      alertFields: [
        { key: "Data", label: this.$t("cards.date_event") },
        { key: "Dev", label: this.$t("cards.device"), tdClass: "nowrap" },
        { key: "Icon", label: "", tdClass: "align-middle" },
        { key: "Desc", label: this.$t("cards.description"), tdClass: "align-middle" }
      ],
      alertItems: [],
      colorIcon: "color: red;",
      colorGrey: "color: grey;",
      colorBlack: "color: black;",
      colorCom: "color: orange;",

    };
  },
  
  mounted() {
    this.alertShadow();
  },

  computed: {
    unitsDetails() {
      return this.$store.state.plantUnits;
    }
  },

  methods: {
    alertShadow() {
      if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;

      var self = this;
      var errorFound = "";
      var errorIcon = "";
      var formatted_date = "";
      this.alertItems = [];
      this.colorIcon = "color: red";
      console.log("DETTAGLI Cu", this.unitsDetails);
      for (var k = 0; k < this.unitsDetails.length; k++) {

        //Errori su centrali
        if (this.unitsDetails[k].cu_error) {
          var dateObj = new Date(this.unitsDetails[k].timestamp);
          formatted_date =
            dateObj.toLocaleDateString() +
            "\n" +
            dateObj.toLocaleTimeString();

          if (this.unitsDetails[k].cu_type === 'sicuro') {
            //errori di Centrale Sicuro
            if (this.unitsDetails[k].cu_error.error_ak_o_luci == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("report_pdf.num_lampade_fail");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_all_chargers_or_fuse == "ON") {
              errorIcon = "fa-battery-full";
              errorFound = this.$t("details_cent.error_all_chargers_or_fuse");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_autonomy_test == "ON") {
              errorIcon = "fa-battery-full";
              errorFound = this.$t("details_cent.error_autonomy_test");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_battery_fuse == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cent.num_lampade_fail");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_battery_low == "ON") {
              errorIcon = "fa-battery-full";
              errorFound = this.$t("details_cent.error_battery_low");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_battery_simmetry == "ON") {
              errorIcon = "fa-battery-full";
              errorFound = this.$t("details_cent.error_battery_simmetry");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_battery_temperature == "ON") {
              errorIcon = "fa-battery-full";
              errorFound = this.$t("details_cent.error_battery_temperature");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_cabinet_isominus == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cent.error_cabinet_isominus");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_cabinet_isoplus == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cent.error_cabinet_isoplus");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_chargers == "ON") {
              errorIcon = "fa-battery-full";
              errorFound = this.$t("details_cent.error_chargers");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_com_cpu_ak == "ON") {
              errorIcon = "fa-solid fa-arrow-down-up-across-line";
              errorFound = this.$t("details_cent.error_com_cpu_ak");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_com_cpu_charger == "ON") {
              errorIcon = "fa-solid fa-arrow-down-up-across-line";
              errorFound = this.$t("details_cent.error_com_cpu_charger");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_com_cpu_io == "ON") {
              errorIcon = "fa-solid fa-arrow-down-up-across-line";
              errorFound = this.$t("details_cent.error_com_cpu_io");
              this.alertItems.push({ 
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_com_cpu_lssa == "ON") {
              errorIcon = "fa-solid fa-arrow-down-up-across-line";
              errorFound = this.$t("details_cent.error_com_cpu_lssa");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_com_cpu_substation == "ON") {
              errorIcon = "fa-solid fa-arrow-down-up-across-line";
              errorFound = this.$t("details_cent.error_com_cpu_substation");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_com_cpu_switch11kw == "ON") {
              errorIcon = "fa-solid fa-arrow-down-up-across-line";
              errorFound = this.$t("details_cent.error_com_cpu_switch11kw");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_functional_test == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cent.error_functional_test");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_io_measures == "ON") {
              errorIcon = "fa-microchip";
              errorFound = this.$t("details_cent.error_io_measures");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_lamp_programming == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cent.error_lamp_programming");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_line_isolation == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cent.error_line_isolation");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_swap_lampade == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cent.error_swap_lampade");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.no_critical_circuit == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cent.no_critical_circuit");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                ColorIcon: "color: orange",
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.no_mains == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cent.no_mains");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                ColorIcon: "color: orange",
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.no_phase1 == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cent.no_phase1");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                ColorIcon: "color: orange",
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.no_phase2 == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cent.no_phase2");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                ColorIcon: "color: orange",
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.no_phase3 == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cent.no_phase3");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                ColorIcon: "color: orange",
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.no_subdistribution == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cent.no_subdistribution");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                ColorIcon: "color: orange",
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.system_inhibited == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cent.system_inhibited");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.warning_charger_off_by_temperature == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cent.warning_charger_off_by_temperature");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                ColorIcon: "color: orange",
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.warning_maintenance == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cent.warning_maintenance");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                ColorIcon: "color: orange",
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_power_supply_broken == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cent.error_power_supply_broken");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_power_supply_out_of_range == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cent.error_power_supply_out_of_range");
              this.alertItems.push({
                Data: formatted_date,
                Dev: self.$t('alerts.centrale'),
                Cent: 'Cu ' + this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            //verifico gli AK
            this.unitsDetails[k].ak.forEach((ak) => {
              //errori di AK
              if (ak.error_com_cpu_ak == "ON") {
                errorIcon = "fa-solid fa-arrow-down-up-across-line";
                errorFound = this.$t("details_cent.error_com_cpu_ak");
                this.alertItems.push({
                  Data: formatted_date,
                  Dev: self.$t('alerts.centrale'),
                  Cent: "AK " + ak.index,
                  Type: this.unitsDetails[k].cu_id,
                  Desc: errorFound,
                  Icon: errorIcon,
                  Online: this.unitsDetails[k].cu_connected
                });
              }
              if (ak.error_line_isolation == "ON") {
                errorIcon = "fa-exclamation-triangle";
                errorFound = this.$t("details_cent.error_line_isolation");
                this.alertItems.push({
                  Data: formatted_date,
                  Dev: self.$t('alerts.centrale'),
                  Cent: "AK " + ak.index,
                  Type: this.unitsDetails[k].cu_id,
                  Desc: errorFound,
                  Icon: errorIcon,
                  Online: this.unitsDetails[k].cu_connected
                });
              }
              //verifico le Linee
              ak.lines.forEach((line => {
                //errori di Linea
                if (line.error_ak_su_current == "ON") {
                  errorIcon = "fa-exclamation-triangle";
                  errorFound = this.$t("details_line.error_ak_su_current");
                  this.alertItems.push({
                    Data: formatted_date,
                    Dev: self.$t('alerts.centrale'),
                    Cent: self.$t('alerts.linea') + " " + line.line_num,
                    Type: this.unitsDetails[k].cu_id,
                    Sub: self.$t('alerts.ak') + " " + ak.index,
                    Desc: errorFound,
                    Icon: errorIcon,
                    Online: this.unitsDetails[k].cu_connected
                  });
                }
                if (line.error_com_cpu_ak == "ON") {
                  errorIcon = "fa-solid fa-arrow-down-up-across-line";
                  errorFound = this.$t("details_cent.error_com_cpu_ak");
                  this.alertItems.push({
                    Data: formatted_date,
                    Dev: self.$t('alerts.centrale'),
                    Cent: self.$t('alerts.linea') + " " + line.line_num,
                    Type: this.unitsDetails[k].cu_id,
                    Sub: self.$t('alerts.ak') + " " + ak.index,
                    Desc: errorFound,
                    Icon: errorIcon,
                    Online: this.unitsDetails[k].cu_connected
                  });
                }
                if (line.error_line_fuse == "ON") {
                  errorIcon = "fa-exclamation-triangle";
                  errorFound = this.$t("details_line.error_line_fuse");
                  this.alertItems.push({
                    Data: formatted_date,
                    Dev: self.$t('alerts.centrale'),
                    Cent: self.$t('alerts.linea') + " " + line.line_num,
                    Type: this.unitsDetails[k].cu_id,
                    Sub: self.$t('alerts.ak') + " " + ak.index,
                    Desc: errorFound,
                    Icon: errorIcon,
                    Online: this.unitsDetails[k].cu_connected
                  });
                }
                if (line.error_line_isolation == "ON") {
                  errorIcon = "fa-exclamation-triangle";
                  errorFound = this.$t("details_cent.error_line_isolation");
                  this.alertItems.push({
                    Data: formatted_date,
                    Dev: self.$t('alerts.centrale'),
                    Cent: self.$t('alerts.linea') + " " + line.line_num,
                    Type: this.unitsDetails[k].cu_id,
                    Sub: self.$t('alerts.ak') + " " + ak.index,
                    Desc: errorFound,
                    Icon: errorIcon,
                    Online: this.unitsDetails[k].cu_connected
                  });
                }
                if (line.warning_line_overcurrent == "ON") {
                  errorIcon = "fa-exclamation-triangle";
                  errorFound = this.$t("details_line.warning_line_overcurrent");
                  this.alertItems.push({
                    Data: formatted_date,
                    Dev: self.$t('alerts.centrale'),
                    Cent: self.$t('alerts.linea') + " " + line.line_num,
                    Type: this.unitsDetails[k].cu_id,
                    Sub: self.$t('alerts.ak') + " " + ak.index,
                    Desc: errorFound,
                    Icon: errorIcon,
                    ColorIcon: "color: orange",
                    Online: this.unitsDetails[k].cu_connected
                  });
                }
                //verifico le lampade
                line.lamps.forEach((lamp => {
                  //errori lampada
                  if (lamp.error_com_ak_lamp == "ON") {
                    errorIcon = "fa-solid fa-arrow-down-up-across-line";
                    errorFound = this.$t("details_lamp.lamp_error_com_ak_lamp");
                    this.alertItems.push({
                      Data: formatted_date,
                      Dev: self.$t('alerts.centrale'),
                      Cent: lamp.lamp_id,
                      Type: this.unitsDetails[k].cu_id,
                      Sub: self.$t('alerts.ak') + " " + ak.index + " " + self.$t('alerts.linea') + " " + line.line_num,
                      Desc: errorFound,
                      Icon: errorIcon,
                      Online: this.unitsDetails[k].cu_connected
                    });
                  }
                  if (lamp.error_dali_com == "ON") {
                    errorIcon = "fa-solid fa-arrow-down-up-across-line";
                    errorFound = this.$t("details_lamp.lamp_error_dali_com");
                    this.alertItems.push({
                      Data: formatted_date,
                      Dev: self.$t('alerts.centrale'),
                      Cent: lamp.lamp_id,
                      Type: this.unitsDetails[k].cu_id,
                      Sub: self.$t('alerts.ak') + " " + ak.index + " " + self.$t('alerts.linea') + " " + line.line_num,
                      Desc: errorFound,
                      Icon: errorIcon,
                      Online: this.unitsDetails[k].cu_connected
                    });
                  }
                  if (lamp.error_dali_hardware == "ON") {
                    errorIcon = "fa-exclamation-triangle";
                    errorFound = this.$t("details_lamp.error_dali_hardware");
                    this.alertItems.push({
                      Data: formatted_date,
                      Dev: self.$t('alerts.centrale'),
                      Cent: lamp.lamp_id,
                      Type: this.unitsDetails[k].cu_id,
                      Sub: self.$t('alerts.ak') + " " + ak.index + " " + self.$t('alerts.linea') + " " + line.line_num,
                      Desc: errorFound,
                      Icon: errorIcon,
                      Online: this.unitsDetails[k].cu_connected
                    });
                  }
                  if (lamp.error_dali_lamp == "ON") {
                    errorIcon = "fa-exclamation-triangle";
                    errorFound = this.$t("details_lamp.lamp_error_dali_lamp");
                    this.alertItems.push({
                      Data: formatted_date,
                      Dev: self.$t('alerts.centrale'),
                      Cent: lamp.lamp_id,
                      Type: this.unitsDetails[k].cu_id,
                      Sub: self.$t('alerts.ak') + " " + ak.index + " " + self.$t('alerts.linea') + " " + line.line_num,
                      Desc: errorFound,
                      Icon: errorIcon,
                      Online: this.unitsDetails[k].cu_connected
                    });
                  }
                  if (lamp.error_hardware == "ON") {
                    errorIcon = "fa-microchip";
                    errorFound = this.$t("details_lamp.lamp_error_hardwarep");
                    this.alertItems.push({
                      Data: formatted_date,
                      Dev: self.$t('alerts.centrale'),
                      Cent: lamp.lamp_id,
                      Type: this.unitsDetails[k].cu_id,
                      Sub: self.$t('alerts.ak') + " " + ak.index + " " + self.$t('alerts.linea') + " " + line.line_num,
                      Desc: errorFound,
                      Icon: errorIcon,
                      Online: this.unitsDetails[k].cu_connected
                    });
                  }
                  if (lamp.error_id_duplicate == "ON") {
                    errorIcon = "fa-exclamation-triangle";
                    errorFound = this.$t("details_lamp.lamp_error_duplicate");
                    this.alertItems.push({
                      Data: formatted_date,
                      Dev: self.$t('alerts.centrale'),
                      Cent: lamp.lamp_id,
                      Type: this.unitsDetails[k].cu_id,
                      Sub: self.$t('alerts.ak') + " " + ak.index + " " + self.$t('alerts.linea') + " " + line.line_num,
                      Desc: errorFound,
                      Icon: errorIcon,
                      Online: this.unitsDetails[k].cu_connected
                    });
                  }
                  if (lamp.error_lamp_programming == "ON") {
                    errorIcon = "fa-exclamation-triangle";
                    // errorFound = this.$t("details_lamp.error_lamp_programming");
                    errorFound = this.$t("details_cent.error_lamp_programming");
                    this.alertItems.push({
                      Data: formatted_date,
                      Dev: self.$t('alerts.centrale'),
                      Cent: lamp.lamp_id,
                      Type: this.unitsDetails[k].cu_id,
                      Sub: self.$t('alerts.ak') + " " + ak.index + " " + self.$t('alerts.linea') + " " + line.line_num,
                      Desc: errorFound,
                      Icon: errorIcon,
                      Online: this.unitsDetails[k].cu_connected
                    });
                  }
                  if (lamp.error_led_full_short == "ON") {
                    errorIcon = "fa-exclamation-triangle";
                    errorFound = this.$t("details_lamp.lamp_error_led_full_short");
                    this.alertItems.push({
                      Data: formatted_date,
                      Dev: self.$t('alerts.centrale'),
                      Cent: lamp.lamp_id,
                      Type: this.unitsDetails[k].cu_id,
                      Sub: self.$t('alerts.ak') + " " + ak.index + " " + self.$t('alerts.linea') + " " + line.line_num,
                      Desc: errorFound,
                      Icon: errorIcon,
                      Online: this.unitsDetails[k].cu_connected
                    });
                  }
                  if (lamp.error_led_open == "ON") {
                    errorIcon = "fa-exclamation-triangle";
                    errorFound = this.$t("details_lamp.lamp_error_led_open");
                    this.alertItems.push({
                      Data: formatted_date,
                      Dev: self.$t('alerts.centrale'),
                      Cent: lamp.lamp_id,
                      Type: this.unitsDetails[k].cu_id,
                      Sub: self.$t('alerts.ak') + " " + ak.index + " " + self.$t('alerts.linea') + " " + line.line_num,
                      Desc: errorFound,
                      Icon: errorIcon,
                      Online: this.unitsDetails[k].cu_connected
                    });
                  }
                  if (lamp.error_led_partial_short == "ON") {
                    errorIcon = "fa-exclamation-triangle";
                    errorFound = this.$t("details_lamp.lamp_error_led_partial_short");
                    this.alertItems.push({
                      Data: formatted_date,
                      Dev: self.$t('alerts.centrale'),
                      Cent: lamp.lamp_id,
                      Type: this.unitsDetails[k].cu_id,
                      Sub: self.$t('alerts.ak') + " " + ak.index + " " + self.$t('alerts.linea') + " " + line.line_num,
                      Desc: errorFound,
                      Icon: errorIcon,
                      Online: this.unitsDetails[k].cu_connected
                    });
                  }
                  if (lamp.error_low_voltage == "ON") {
                    errorIcon = "fa-exclamation-triangle";
                    errorFound = this.$t("details_lamp.lamp_error_low_voltage");
                    this.alertItems.push({
                      Data: formatted_date,
                      Dev: self.$t('alerts.centrale'),
                      Cent: lamp.lamp_id,
                      Type: this.unitsDetails[k].cu_id,
                      Sub: self.$t('alerts.ak') + " " + ak.index + " " + self.$t('alerts.linea') + " " + line.line_num,
                      Desc: errorFound,
                      Icon: errorIcon,
                      Online: this.unitsDetails[k].cu_connected
                    });
                  }
                  if (lamp.error_polarity_reverse == "ON") {
                    errorIcon = "fa-exclamation-triangle";
                    errorFound = this.$t("details_lamp.lamp_error_reverse_polarity");
                    this.alertItems.push({
                      Data: formatted_date,
                      Dev: self.$t('alerts.centrale'),
                      Cent: lamp.lamp_id,
                      Type: this.unitsDetails[k].cu_id,
                      Sub: self.$t('alerts.ak') + " " + ak.index + " " + self.$t('alerts.linea') + " " + line.line_num,
                      Desc: errorFound,
                      Icon: errorIcon,
                      Online: this.unitsDetails[k].cu_connected
                    });
                  }
                  if (lamp.error_under_threshold == "ON") {
                    errorIcon = "fa-exclamation-triangle";
                    errorFound = this.$t("details_lamp.lamp_error_under_threshold");
                    this.alertItems.push({
                      Data: formatted_date,
                      Dev: self.$t('alerts.centrale'),
                      Cent: lamp.lamp_id,
                      Type: this.unitsDetails[k].cu_id,
                      Sub: self.$t('alerts.ak') + " " + ak.index + " " + self.$t('alerts.linea') + " " + line.line_num,
                      Desc: errorFound,
                      Icon: errorIcon,
                      Online: this.unitsDetails[k].cu_connected
                    });
                  }
                  if (lamp.error_com_cpu_ak == "ON") {
                    errorIcon = "fa-solid fa-arrow-down-up-across-line";
                    errorFound = this.$t("details_cent.error_com_cpu_ak");
                    this.alertItems.push({
                      Data: formatted_date,
                      Dev: self.$t('alerts.centrale'),
                      Cent: lamp.lamp_id,
                      Type: this.unitsDetails[k].cu_id,
                      Sub: self.$t('alerts.ak') + " " + ak.index + " " + self.$t('alerts.linea') + " " + line.line_num,
                      Desc: errorFound,
                      Icon: errorIcon,
                      Online: this.unitsDetails[k].cu_connected
                    });
                  }
                  if (lamp.error_line_fuse == "ON") {
                    errorIcon = "fa-exclamation-triangle";
                    errorFound = this.$t("details_line.error_line_fuse");
                    this.alertItems.push({
                      Data: formatted_date,
                      Dev: self.$t('alerts.centrale'),
                      Cent: lamp.lamp_id,
                      Type: this.unitsDetails[k].cu_id,
                      Sub: self.$t('alerts.ak') + " " + ak.index + " " + self.$t('alerts.linea') + " " + line.line_num,
                      Desc: errorFound,
                      Icon: errorIcon,
                      Online: this.unitsDetails[k].cu_connected
                    });
                  }
                }));              
              }));
            });
          } else {
            if (this.unitsDetails[k].cu_error.error_batt_low_voltage == "ON") {
              errorIcon = "fa-battery-full";
              errorFound = this.$t("details_cu_modal.cu_error_batt_low_voltage");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type.replace("ble",""),
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_batt_not_connected == "ON") {
              errorIcon = "fa-battery-full";
              errorFound = this.$t(
                "details_cu_modal.cu_error_batt_not_connected"
              );
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type.replace("ble",""),
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
            if (this.unitsDetails[k].cu_error.error_duplicated_id_lamp == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t(
                "details_cu_modal.cu_error_duplicated_id_lamp"
              );
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type.replace("ble",""),
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
    
            if (this.unitsDetails[k].cu_error.error_wiring == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cu_modal.cu_error_wiring");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type.replace("ble",""),
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }
    
            if (this.unitsDetails[k].cu_error.error_overload == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_cu_modal.cu_error_overload");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].cu_id,
                Type: this.unitsDetails[k].cu_type.replace("ble",""),
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

          if (this.unitsDetails[k].cu_error.error_more_32_lamp_in_config == "ON") {
            errorIcon = "fa-exclamation-triangle";
            errorFound = this.$t(
              "details_cu_modal.cu_error_more_32_lamp_in_config"
            );
            this.alertItems.push({
              Data: formatted_date,
              Dev: this.unitsDetails[k].cu_type.replace("ble",""),
              Cent: this.unitsDetails[k].cu_id,
              Type: this.unitsDetails[k].cu_type.replace("ble",""),
              Desc: errorFound,
              Icon: errorIcon,
              Online: this.unitsDetails[k].cu_connected
            });
          }

          //Errori su lampade di emergenza
          for (var n = 0; n < this.unitsDetails[k].lamps.length; n++) {
            if (this.unitsDetails[k].lamps[n].error_batt_short == "ON") {
              errorIcon = "fa-battery-full";
              errorFound = this.$t("details_lamp.lamp_error_batt_short");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            if (this.unitsDetails[k].lamps[n].error_batt_test == "ON") {
              errorIcon = "fa-battery-full";
              errorFound = this.$t("details_lamp.lamp_error_batt_test_funz");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            if (this.unitsDetails[k].lamps[n].error_batt_test_auto == "ON") {
              errorIcon = "fa-battery-full";
              errorFound = this.$t("details_lamp.lamp_error_batt_test_auto");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            if (this.unitsDetails[k].lamps[n].error_tubo_UV == "ON") {
              errorIcon = "fa-square";
              errorFound = this.$t("details_lamp.lamp_error_tubo_UV");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            if (this.unitsDetails[k].lamps[n].error_com == "ON" && this.unitsDetails[k].lamps[n].error_hardware == "OFF") {
              errorIcon = "fa-exclamation-circle";
              errorFound = this.$t("details_lamp.lamp_error_com");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            if (this.unitsDetails[k].lamps[n].error_hardware == "ON" && this.unitsDetails[k].lamps[n].error_com == "OFF" && this.unitsDetails[k].lamps[n].error_comm_radio_lamp == "OFF") {
              errorIcon = "fa-microchip";
              errorFound = this.$t("details_lamp.lamp_error_hardware");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            if ((this.unitsDetails[k].lamps[n].error_hardware == "ON" && this.unitsDetails[k].lamps[n].error_com == "ON") || this.unitsDetails[k].lamps[n].error_comm_radio_lamp == "ON") {
              errorIcon = "fa-microchip";
              errorFound = this.$t("details_lamp.lamp_error_module");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            if (this.unitsDetails[k].lamps[n].error_led == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_lamp.lamp_error_led");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            if (this.unitsDetails[k].lamps[n].nodo_orfano == true) {
              errorIcon = "fa fa-x2 fa-wifi ml-2";
              errorFound = this.$t("orfano");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            } }

            //Errori su lampade di illuminazione
            for (var n = 0; n < this.unitsDetails[k].lamps_illum.length; n++) {
            if (this.unitsDetails[k].lamps_illum[n].error_batt_short == "ON") {
              errorIcon = "fa-battery-full";
              errorFound = this.$t("details_lamp.lamp_error_batt_short");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps_illum[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            if (this.unitsDetails[k].lamps_illum[n].error_batt_test == "ON") {
              errorIcon = "fa-battery-full";
              errorFound = this.$t("details_lamp.lamp_error_batt_test");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps_illum[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            if (this.unitsDetails[k].lamps_illum[n].error_tubo_UV == "ON") {
              errorIcon = "fa-square";
              errorFound = this.$t("details_lamp.lamp_error_tubo_UV");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps_illum[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            if (this.unitsDetails[k].lamps_illum[n].error_com == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_lamp.lamp_error_com");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps_illum[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            if (this.unitsDetails[k].lamps_illum[n].error_hardware == "ON") {
              errorIcon = "fa-microchip";
              errorFound = this.$t("details_lamp.lamp_error_hardware");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps_illum[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            if (this.unitsDetails[k].lamps_illum[n].error_led == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_lamp.lamp_error_led");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps_illum[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            if (this.unitsDetails[k].lamps_illum[n].error_overpower == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_lamp.lamp_error_overpower");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps_illum[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            if (this.unitsDetails[k].lamps_illum[n].error_overvoltage == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_lamp.lamp_error_overvoltage");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps_illum[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            if (this.unitsDetails[k].lamps_illum[n].error_underpower == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_lamp.lamp_error_underpower");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps_illum[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            if (this.unitsDetails[k].lamps_illum[n].error_undervoltage == "ON") {
              errorIcon = "fa-exclamation-triangle";
              errorFound = this.$t("details_lamp.lamp_error_undervoltage");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps_illum[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            if (this.unitsDetails[k].lamps_illum[n].nodo_orfano == true) {
              errorIcon = "fa fa-x2 fa-wifi ml-2";
              errorFound = this.$t("orfano");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].lamps_illum[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            } }


            //Errori su sensori
            for (var n = 0; n < this.unitsDetails[k].sensors.length; n++) {
  
            if (this.unitsDetails[k].sensors[n].nodo_orfano == true) {
              errorIcon = "fa fa-x2 fa-wifi ml-2";
              errorFound = this.$t("orfano");
              this.alertItems.push({
                Data: formatted_date,
                Dev: this.unitsDetails[k].cu_type.replace("ble",""),
                Cent: this.unitsDetails[k].sensors[n].id,
                Type: this.unitsDetails[k].cu_id,
                Desc: errorFound,
                Icon: errorIcon,
                Online: this.unitsDetails[k].cu_connected
              });
            }

            }

          }
        }
      }
      //se non sono presenti errori in nessuna centrale, allora segnalo che tutto è ok con pallino verde
      if (errorFound == "") {
        var noErrorIcon = "fa-check-circle ";
        this.colorIcon = "color: yellowgreen";
        var noError = this.$t("details_lamp.lamp_no_error");
        this.alertItems.push({ Data: noError, Icon: noErrorIcon, Online: true });
      }
      else
      {
        //sort errors list
        this.alertItems = this.alertItems.sort((a, b) => {
          if (a.Online && !b.Online) {
            return -1
          } else {
            return 0
          }
        });
      }
    }
  },
}
</script>